import { Component, OnInit } from '@angular/core';
import { Router, RouterModule, RouterOutlet } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { IserverService } from './services/iserver.service';
import { IServerModelState } from './states/iserver-model.state';
import { IServerObjectTypeState } from './states/iserver-objecttypes.state';
import { Gen_Model } from './types/generated-model.type';
import { Gen_ObjectType } from './types/generated-objectType.type';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-secure',
  templateUrl: './secure.component.html',
  styleUrls: ['./secure.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule],
})
export class SecureComponent {
  constructor(
    public iServerService: IserverService,
    private msalService: MsalService
  ) { }

  @Select(IServerModelState.loading) modelsLoading$:
    | Observable<Gen_Model[]>
    | undefined;
  @Select(IServerObjectTypeState.loading) objectTypesLoading$:
    | Observable<Gen_Model[]>
    | undefined;

  logout() {
    this.msalService.logout();
  }
}
